app.factory(
    'FormApiErrorHandler', FormApiErrorHandler
);

function FormApiErrorHandler() {
    return {
        /**
         * Handles form errors
         *
         * @param form jQuery object
         * @param errors API errors
         */
        handle : function (form, errors) {
            var formGroups = form.find('.form-group');
            formGroups.removeClass('has-error');

            $('.input-error').remove();

            for (var i in errors) {
                if (errors[i].path) {
                    var input = $('#' + errors[i].path);
                    var formGroup = input.parents('.form-group');
                    formGroup.addClass('has-error');
                    input.after(
                        '<p class="input-error text-red">' + errors[i].message + '</p>'
                    );
                } else {
                    formGroups.last().after(
                        '<p class="input-error text-center text-red">' + errors[i] + '</p>'
                    );
                }
            }
        }
    };
}